import { render, staticRenderFns } from "./packvip.vue?vue&type=template&id=cadb109e&"
import script from "./packvip.vue?vue&type=script&lang=js&"
export * from "./packvip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cadb109e')) {
      api.createRecord('cadb109e', component.options)
    } else {
      api.reload('cadb109e', component.options)
    }
    module.hot.accept("./packvip.vue?vue&type=template&id=cadb109e&", function () {
      api.rerender('cadb109e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/packvip.vue"
export default component.exports